import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=5532885d&scoped=true&"
import script from "./product_list.vue?vue&type=script&lang=js&"
export * from "./product_list.vue?vue&type=script&lang=js&"
import style0 from "./product_list.vue?vue&type=style&index=0&id=5532885d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5532885d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5532885d')) {
      api.createRecord('5532885d', component.options)
    } else {
      api.reload('5532885d', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=5532885d&scoped=true&", function () {
      api.rerender('5532885d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/channelPool/channelPoolDetails/form/product_list.vue"
export default component.exports